exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@-webkit-keyframes resizeSensorVisibility {\nfrom { top: 0;\n}\n}\n@keyframes resizeSensorVisibility {\nfrom { top: 0;\n}\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1cfa7f27","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-resize-sensor/src/resize-sensor.vue
// module id = 1515
// module chunks = 2